<template>
  <div class="news-item-box" @click="itemClick">
    <img :src="item.image" alt="news-item" />
    <p class="title1">{{ item.title }}</p>
    <p class="title2">
      <i class="el-icon-time" />
      {{ dateFormatter(new Date(item.createTime), "yyyy-MM-dd hh:mm:ss") }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    itemClick() {
      this.$router.push({ path: "/newsDetail", query: { id: this.item.articleId } });
    },
  },
};
</script>

<style lang="less" scoped>
.news-item-box {
  width: 445px;
  cursor: pointer;
  position: relative;
  background: #ffffff;
  border-radius: 12px 12px 12px 12px;
  img {
    width: 100%;
    height: 250px;
    object-fit: cover;
    border-radius: 12px 12px 12px 12px;
  }
  p {
    margin: 20px;
  }
  .title1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 800;
    font-size: 20px;
    color: #333333;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; /* 限制为两行 */
    overflow: hidden;
  }
  .title2 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #999999;
  }
}
</style>
